module.exports = __webpack_public_path__ + "static/media/group.8483dd1f.png";